import React from 'react';
import { motion } from 'framer-motion';

const TaglineBanner = () => {
  return (
    <section 
      className="py-16 md:py-20"
      style={{ backgroundColor: '#111111' }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto px-4 text-center"
      >
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
          Justice is Not a Favor, it’s Your Right. Your case, our Fight.
        </h2>
        <p className="text-lg" style={{ color: '#999999' }}>
          NAMORISATYA LEGAL & ASSOCIATES — Committed to delivering results for every client.
        </p>
      </motion.div>
    </section>
  );
};

export default TaglineBanner;